import Axios, { AxiosError } from 'axios';

export const isAxiosErrorWithCode = (error: Error | AxiosError, errorCode: number) =>
  Axios.isAxiosError(error) && error.response && error.response.status === errorCode;
